import React from 'react'
import { useTheme } from '@mui/material/styles';
import { Button } from '@mui/material';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ClearIcon from '@mui/icons-material/Clear';
import "./TitleDivSeo.css"
import { useContext } from 'react';
import { StatusContext } from '../ContextApiStatus';

export default function DialogDescription(props) {

  const {  statusdescription,numOfStatusdescription } = useContext(StatusContext);


    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = (e) => {
        setOpen(false);
      }
      const theme = useTheme();
      const { description } = props;

      // Check if title is defined before accessing its length
      const numberOfCharacters = description ? description.length : 0;
  return (
    <div>
      <div style={{marginTop:"10px"}} className='TitleDivSeo' onClick={handleClickOpen}>
      <div className="CARD" onClick={handleClickOpen}>
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
        <h3>الوصف الخاص بك</h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        <Typography fontWeight="md" textColor="success.plainColor">
           {props.description}
        </Typography>
        <Typography level="body-sm">
          {numberOfCharacters === 0 ?<h2
          style={{ color: 'rgb(78, 181, 76)' }}>
            "لا يوجد وصف لموقعك 😯"</h2>  : `يحتوي الوصف الخاص بموقعك على عدد من الحروف وهو ${numberOfCharacters}`}
        </Typography>
      </CardContent>
        { statusdescription === "true" ? (
  <CheckIcon style={{ color: "#27ae60", fontSize: "50px" }} />
) : statusdescription === "correct" ? (
  <PriorityHighIcon style={{ color: "#f39c12",fontSize: "50px" }} />
) : statusdescription === "false" ? (
  <ClearIcon style={{ color: "red",fontSize: "50px" }} />
) : null }
    </Card>
    </div>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{direction:"rtl"}}>
          <DialogContentText id="alert-dialog-description" style={{color:"rgb(78, 181, 76)"}}>
           الوصف التعريفي لموقع الويب يشكل عنصرًا أساسيًا في استراتيجية تحسين محركات البحث (SEO)، حيث يسهم بشكل كبير في تحسين رؤية الموقع على شبكة الإنترنت. يُعتبر الوصف التعريفي كوصف قصير وجذاب يظهر تحت عنوان الموقع في نتائج محركات البحث، ويهدف إلى جذب انتباه الزوار المحتملين وتحفيزهم على زيارة الموقع
          </DialogContentText>
        </DialogContent>
        <Button onClick={(e) => { e.stopPropagation(); handleClose(); }}>close</Button>
      </Dialog>
    </div>
    </div>
  )
}
